import { PaymentElement } from '@stripe/react-stripe-js';
import { StripePaymentElementOptions } from '@stripe/stripe-js';

interface StripePaymentElementProps {
  onChange?: (event: { complete: boolean }) => void;
}

export default function StripePaymentElement({ onChange }: StripePaymentElementProps) {
  const paymentOptions: StripePaymentElementOptions = {
    layout: {
      type: 'tabs',
      defaultCollapsed: false,
    },
    paymentMethodOrder: ['card'],
    // Disable wallets (Google Pay, Apple Pay) in the Payment Element
    // since we're using Express Checkout Element for those
    wallets: {
      applePay: 'never',
      googlePay: 'never',
    },
    defaultValues: {
      billingDetails: {
        address: {
          country: 'US',
        },
      },
    },
    fields: {
      billingDetails: {
        address: {
          country: 'never',
          postalCode: 'never',
        },
      },
    },
    terms: {
      card: 'never',
    },
  };

  return <PaymentElement id="payment-element" options={paymentOptions} onChange={onChange} />;
}
